import React from 'react';
import { ExternalLink } from 'lucide-react';

const BlogSocialTab = ({ formData, setFormData }) => {
  const previewTitle = formData.og_title || formData.seo_title || formData.title || 'Your Blog Title';
  const previewDesc = formData.og_description || formData.seo_description || 'Your blog description will appear here...';

  return (
    <div className="space-y-5">
      <div>
        <label className="block text-sm font-bold text-gray-700 mb-2">og:title</label>
        <input
          type="text"
          data-testid="social-og-title-input"
          value={formData.og_title || ''}
          onChange={(e) => setFormData((prev) => ({ ...prev, og_title: e.target.value }))}
          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder={formData.seo_title || formData.title || 'Title for social sharing...'}
        />
        <p className="mt-1 text-xs text-gray-500">Falls back to Title Tag, then Title, if left empty</p>
      </div>

      <div>
        <label className="block text-sm font-bold text-gray-700 mb-2">og:description</label>
        <textarea
          data-testid="social-og-description-input"
          value={formData.og_description || ''}
          onChange={(e) => setFormData((prev) => ({ ...prev, og_description: e.target.value }))}
          rows={3}
          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder={formData.seo_description || 'Description for social sharing...'}
        />
        <p className="mt-1 text-xs text-gray-500">Falls back to Meta Description if left empty</p>
      </div>

      <div>
        <h4 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
          <ExternalLink size={16} />Preview on Social Media
        </h4>
        <div data-testid="social-preview-card" className="border border-gray-200 rounded-xl overflow-hidden bg-white max-w-md">
          <div className="bg-gray-50 p-4">
            {formData.featured_image && (
              <div className="w-full h-48 rounded-lg overflow-hidden mb-3 bg-gray-200">
                <img src={formData.featured_image} alt="Social preview" className="w-full h-full object-cover" />
              </div>
            )}
            <div className="space-y-1">
              <p className="text-xs text-gray-500 uppercase tracking-wide">iambivas.in</p>
              <h3 className="font-bold text-gray-900 line-clamp-2">{previewTitle}</h3>
              <p className="text-sm text-gray-600 line-clamp-2">{previewDesc}</p>
            </div>
          </div>
        </div>
        <p className="mt-2 text-xs text-gray-500">How your post will appear when shared on Facebook, LinkedIn, Twitter, etc.</p>
      </div>
    </div>
  );
};

export default BlogSocialTab;
